import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import React, { useEffect, useState } from "react";
import "./BillingDetails.css";
// Removed unused InformationModal
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  getInvoiceList,
  getMedicalAlertUserDetail,
} from "redux/MedicalAlertUsers/actions";
import {
  payment,
  getPaymentRedirectionLink,
  getBankAccountTypes,
  getBillingCardDetail,
  getBillingBankDetail,
  getCardList,
} from "redux/Payments/actions";
import { useHistory, useLocation } from "react-router-dom";
import { ROUTES_CONSTANTS } from "routes/route-constants";
// Removed unused ChangesSavedModal
import SubscriberInformationCard from "components/layout/subscriber-information-card/SubscriberInformationCard";
import OpenSecurePageModal from "components/layout/open-secure-page-modal/OpenSecurePageModal";
import BillingDetailCard from "components/layout/billing-detail-card/BillingDetailCard";
import PaymentSuccessFailureModal from "components/layout/payment-success-failure-modal/PaymentSuccessFailureModal";
import { mapCardTypeFromCode } from "utility";

// Removed unused monthArray

const BillingDetails = () => {

  // Removed unused ChangesSavedModal, snackBarMessage, InformationModal state
  const [isLoading, setIsLoading] = useState(false);
  const { loading } = useSelector((store) => store?.medicalAlertUsers);
  const userData = useSelector((store) => store?.auth?.userData);
  const { paymentUrl, loading: paymentsLoading } = useSelector((store) => store?.payments);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isFromPayment = location?.state?.isFromPayment;
  const medicalUserDetail = location?.state?.medicalUserDetail;
  const payments = location?.state?.payments || {};
  const { cardDetails } = payments;
  const [showWebView, setShowWebView] = useState(!isFromPayment);
  const [iframeLoading, setIframeLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentModal, setPaymentModal] = useState({ isVisible: false, type: "", transactionData: {} });

  useEffect(() => {
    if (showWebView) {
      setIsLoading(true);
      setIframeLoading(true);
      const param = {
        dispatch,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
        medicalAlertUserId: medicalUserDetail?.medical_alert_user_id,
      };
      getPaymentRedirectionLink(param);
    }
    return () => {
      setIsLoading(false);
      setIframeLoading(false);
    };
  }, [showWebView, dispatch, userData, medicalUserDetail]);

  // Effect: only transition into iframe loading when in iframe flow
  useEffect(() => {
    if (paymentUrl && isLoading && showWebView) {
      setIsLoading(false);
      setIframeLoading(true); // Start iframe loading when URL is available and iframe flow is active
    }
  }, [paymentUrl, isLoading, showWebView]);

  // Calculate total amount from invoices
  useEffect(() => {
    if (isFromPayment && location?.state?.invoices) {
      const total = location.state.invoices.reduce((sum, invoice) => {
        return sum + (parseFloat(invoice.amount) || 0);
      }, 0);
      setTotalAmount(total);
    }
  }, [isFromPayment, location?.state?.invoices]);

  // Handle single invoice item from route params
  useEffect(() => {
    const single = location?.state?.invoiceItem;
    const amount = parseFloat(single?.invoice_amount) || 0;
    setTotalAmount(amount);
    return () => {
      setTotalAmount(0);
    };
  }, [location?.state?.invoiceItem]);

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      setTotalAmount(0);
      setIsLoading(false);
      setShowWebView(false);
    };
  }, []);

  const onEditBillingDetails = () => {
    // When editing/adding billing info during payment flow, open iframe
    setShowWebView(true);
  };

  const handlePayment = () => {
    const payload = createPaymentPayload();
    if (!payload) return;
    setIsLoading(true);
    payment({
      dispatch,
      payload,
      history,
      getInvoices: (userId) =>
        getInvoiceList({ dispatch, history, medical_alert_user_id: userId }),
      onSuccess: onPaymentSuccess,
      onError: onPaymentError,
    });
  };

  const handEditDetails = () => {
    const param = {
      dispatch,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      emergency_contract_id: medicalUserDetail?.service_contract_id,
      medical_alert_user_id: medicalUserDetail?.medical_alert_user_id,
      user_device_id: undefined,
      is_visible: false,
    };
    getMedicalAlertUserDetail(param);
    getBankAccountTypes(param);
    if (!userData?.isGuestUser) {
      getBillingCardDetail(param);
      getBillingBankDetail(param);
      getCardList(param);
    }
    setShowWebView(false)
  };

  // mapCardTypeFromCode is imported from utility

  const createPaymentPayload = () => {
    const single = location?.state?.invoiceItem || location?.state?.invoices?.[0];
    if (!single) return null;
    return {
      medical_alert_user_id: medicalUserDetail?.medical_alert_user_id,
      invoice_id: single?.invoice_id,
    };
  };

  const onPaymentSuccess = (data) => {
    setIsLoading(false);
    const result = data?.result || {};
    const paymentMethodStr = result?.payment_type === "credit_card"
      ? `${mapCardTypeFromCode(result?.card_type)} Ending in ${result?.payment_details || ""}`
      : (cardDetails ? `${cardDetails?.card_type} Ending in ${cardDetails?.last_4_digits}` : "Payment Method");

    setPaymentModal({
      isVisible: true,
      type: "success",
      transactionData: {
        amount: `$${totalAmount?.toFixed(2)}`,
        paymentMethod: paymentMethodStr,
        date: result?.payment_created_at ? moment(result?.payment_created_at).format('MMMM DD, YYYY, h:mm A') : moment().format('MMMM DD, YYYY, h:mm A'),
        transactionId: result?.transaction_reference || data?.transaction_id || data?.id,
        invoiceUrl: result?.invoice_url,
        ...data,
      },
    });
  };

  const onPaymentError = (_) => {
    setIsLoading(false);
    setPaymentModal({
      isVisible: true,
      type: "failure",
      transactionData: { errorMessage: titles?.button_error_message },
    });
  };


  const downLoadInvoice = () => {
    const url = paymentModal?.transactionData?.invoiceUrl;
    if (!url) return;
    try {
      setIsLoading(true);
      const fileName = `${paymentModal?.transactionData?.transactionId || 'invoice'}_${Math.floor(Math.random() * 100)}.pdf`;
      fetch(url)
        .then((response) => response?.blob())
        .then((blob) => {
          const objectUrl = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = objectUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(objectUrl);
          setIsLoading(false);
        })
        .catch(() => {
          window.open(url, '_blank');
          setIsLoading(false);
        });
    } catch (_) {
      window.open(url, '_blank');
      setIsLoading(false);
    }
  }

  return (
    <MainLayout
      text={titles?.billing_details}
      isBackHide={false}
      isNavbar={true}
      white={true}
      isLoading={loading || paymentsLoading || isLoading}
      fullWidthScreen={showWebView}
      onBackClick={isFromPayment && showWebView ? () => handEditDetails() : undefined}
    >
      {/* Removed unused modals */}
      <PaymentSuccessFailureModal
        show={paymentModal?.isVisible}
        type={paymentModal?.type === 'success' ? 'success' : 'failure'}
        onClose={() => {
          setPaymentModal({ isVisible: false, type: '', transactionData: {} });
          history.push(ROUTES_CONSTANTS.invoicesAndBills);
        }}
        onViewReceipt={() => downLoadInvoice()}
        onPaymentFailure={() => setPaymentModal({ isVisible: false, type: '', transactionData: {} })}
        transactionData={paymentModal?.transactionData}
      />
      <OpenSecurePageModal
        show={iframeLoading}
        onClose={() => {
          setIframeLoading(false);
        }}
      />


      {/* Conditional iframe when iframe flow is active */}
      {showWebView ? (
        <div className="iframe_container">
          {paymentUrl ? (
            <iframe
              src={paymentUrl}
              frameBorder="0"
              title="Billing Details Iframe"
              onLoad={() => {
                setIframeLoading(false);
              }}
              onError={() => {
                setIframeLoading(false);
                console.error("Iframe loading error");
              }}
              style={{
                width: '100%',
                height: '100%'
              }}
            />
          ) : null}
        </div>
      ) : (
        <>
          <SubscriberInformationCard medicalUserDetail={medicalUserDetail} />
          <BillingDetailCard
            medicalUserDetail={medicalUserDetail}
            totalAmount={totalAmount}
            invoiceItem={location?.state?.invoiceItem}
            onEditBillingDetails={onEditBillingDetails}
            onPayment={() => handlePayment()}
          />
        </>
      )}

    </MainLayout>
  );
};

export default BillingDetails;
